import React from "react";
import {WorkflowRunListObject} from "@/types/workflowRuns.js";
import ApplicationCompletedViewV2 from "@/components/TaskHub/ApplicationCompletedViewV2.js";

type ApplicationCompletedViewProps = {
  application: WorkflowRunListObject;
};

const ApplicationCompletedView = (props: ApplicationCompletedViewProps) => {
  const {application} = props;

  if(Object.keys(application?.workflow_run?.workflow_outcomes).length) {
    return (
      <ApplicationCompletedViewV2 application={application} />
    )
  }

  return (
    <div className="animate-fade-in m-6 rounded bg-green-50 p-6 py-20 text-center shadow-lg">
      <div className="flex flex-col items-center gap-4">
        <div className="text-4xl text-green-600">
          <span aria-label="Celebration" role="img">
            🎉
          </span>
        </div>
        <h1 className="text-2xl font-semibold text-green-800">
          Task Completed Successfully!
        </h1>
        <p className="text-lg text-green-700">
          Your task is now completed.
        </p>
        <div className="mt-4 hidden text-gray-600">
          <h3 className="text-lg font-medium">Summary</h3>
          <ul className="mt-2 text-sm">
            <li>
              <strong>Task ID:</strong>{' '}
              {application?.workflow_run?.workflow_run_id}
            </li>
            <li>
              <strong>Duration:</strong> 15 minutes
            </li>
            <li>
              <strong>Actions Taken:</strong> Automation Completed
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
};

export default ApplicationCompletedView;
